import { useReveal } from "../hooks/useReveal";

export default function Tour() {
  const { ref, visible } = useReveal();

  return (
    <section
      id="tour"
      data-testid="tour-section"
      ref={ref}
      className={`relative bg-white py-28 md:py-36 px-6 md:px-12 lg:px-20 reveal ${
        visible ? "in-view" : ""
      }`}
    >
      <div className="max-w-[1300px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="overline mb-5">live · tour</div>
            <h2 className="font-serif-display text-5xl md:text-7xl text-[#0A0A0A] leading-[0.95] tracking-tight">
              <span className="italic">Live</span> shows.
            </h2>
          </div>
          <p className="text-base md:text-lg text-[#595959] leading-relaxed max-w-md">
            Dates being arranged. Sign up below to be the first to know.
          </p>
        </div>

        <div
          data-testid="tour-empty-state"
          className="border-t border-b border-[#E6EAEF] py-24 md:py-32 text-center"
        >
          <div className="overline mb-6">no dates yet</div>
          <h3 className="font-serif-display text-3xl md:text-4xl text-[#0A0A0A] italic leading-tight max-w-2xl mx-auto">
            "More to come. Bring a friend."
          </h3>
        </div>
      </div>
    </section>
  );
}
